import { SocialLinks } from 'social-links';
import { RatingLabels, UserExperience, UserProfileStep, UserStatus } from "../consts/types/user";
import store from "../reducers";

export const socialLinks = new SocialLinks();

export function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export const isStepNotComplete = (step: UserProfileStep) => {
  const user = store.getState().user.currentUser;
  if (!user) {
    return true;
  }
  switch (step) {
    case UserProfileStep.PersonalDetails:
      return !user.name || !user.email || !user.phone
    // || (user.largeCompanies && !user.largeCompaniesDocument) 
    // ||(user.startup && !user.startupDocument) 
    // || (user.management && !user.managementDocument);
    case UserProfileStep.EducationAndExperience:
      return (!user.education || user.education.length === 0 /*|| (user.education.length > 0 && user.education.some(edu => !edu.document))*/)
    // || (user.experience && user.experience.length > 0 && user.experience.some(exp => !exp.document));
    case UserProfileStep.Recommenders:
      return !user.recommenders || user.recommenders.length == 0;
    case UserProfileStep.SocialAccounts:
      return !user.social || user.social.length < 1;
    case UserProfileStep.SkillsTest:
      return !user.skills || user.skills.length < 1 /*|| !user.skillsTestLink || !user.field*/;
    // case UserProfileStep.PersonalityQuiz:
    //   return !user.personality || Object.values(user.personality).filter(val => !!val.rating).length < PersonalityQuestionDetails.length;
  }
}

export const getStatusValue = (ignoreApproved?: boolean) => {
  const user = store.getState().user.currentUser;
  // if (user?.approved && !ignoreApproved) {
  //   return 100;
  // }
  let score = 100;
  if (isStepNotComplete(UserProfileStep.PersonalDetails)) {
    score -= 10;
  }
  if (isStepNotComplete(UserProfileStep.EducationAndExperience)) {
    score -= 20;
  }
  if (isStepNotComplete(UserProfileStep.Recommenders)) {
    score -= 10;
  }
  if (isStepNotComplete(UserProfileStep.SocialAccounts)) {
    score -= 10;
  }
  if (isStepNotComplete(UserProfileStep.SkillsTest)) {
    score -= 20;
  }
  // if (isStepNotComplete(UserProfileStep.PersonalityQuiz)) {
  //   score -= 20;
  // }
  return score;
}

export const getFieldStatusColor = (status: UserStatus, checkDocument = false, document?: string | null) => {
  if (checkDocument && !document) {
    return "#d32f2f";
  }
  else {
    if (status === UserStatus.Pending) {
      return "#ed8f02";
    }
    else if (status === UserStatus.NotVerified) {
      return "#d32f2f";
    }
    else {
      return "#2f9234";
    }
  }
}

export function getRatingLabelText(value: number) {
  return `${value} Star${value !== 1 ? 's' : ''}, ${RatingLabels[value]}`;
}

export const getExperienceYears = (experienceArr: UserExperience[]) => {
  if (experienceArr.length === 0) {
    return 0;
  }
  const years = new Set();
  experienceArr.forEach(exp => {
    if (isNaN(exp.fromYear) || isNaN(exp.toYear)) {
      return 0;
    }
    const from = exp.fromYear;
    const to = exp.toYear === -1 ? new Date().getFullYear() : exp.toYear;
    for (let i = from; i <= to; i++) {
      years.add(i);
    }
  });

  return years.size;
}